import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Meteors } from '@stianlarsen/meteors'
import './MyStory.css'

gsap.registerPlugin(ScrollTrigger)

const H = ({ children }) => <span className="impact-highlight">{children}</span>

const highlights = [
  {
    id: 'pnl',
    content: (
      <>
        I led a React Native trading journal from zero to App Store and Google Play launch,
        reaching <H>10K+ downloads</H> and <H>6K+ users</H> in months. Built a native Kotlin
        Discipline Mode, integrated <H>20+ brokerages</H> via SnapTrade, and processing <H>500+ daily trade syncs</H>.
      </>
    ),
  },
  {
    id: 'ridenear',
    content: (
      <>
        At RideNear, a ride-hailing app, I redesigned B2B and B2C dashboards with Next.js
        and NestJS, cutting configuration time by <H>40%</H> with RBAC across{' '}
        <H>45 permissions</H>. Engineered an MCP-connected AI agent that helped secure
        funding and onboard <H>2 enterprise clients</H>, plus a CMS with DeepL for faster
        localized content.
      </>
    ),
  },
  {
    id: 'opensource',
    content: (
      <>
        I contributed to Expensify, a <H>15M+ user</H> app, fixing critical production bugs
        and earning a <H>$500 bounty</H>. Through Google Summer of Code I built B0Bot with
        an ingestion-service pulling articles from RSS and a notification service sending
        newsletters to users via BullMQ. Also shipped <H>13+ merged PRs</H> to JSON-Schema.
      </>
    ),
  },
  {
    id: 'quickstart',
    content: (
      <>
        I created QuickStart AI, an embeddable RAG chatbot on npm with{' '}
        <H>1,500+ weekly downloads</H>, hybrid BM25 and vector search, and a FastAPI backend
        handling <H>40+ concurrent admin sessions</H>.
      </>
    ),
  },
  {
    id: 'clients',
    content: (
      <>
        I built a franchise platform for R&amp;B Tea serving <H>1,500+ locations</H> that
        generated <H>100+ partnership requests</H>, San Tommaso resort booking with Guesty
        and Stripe where localization <H>doubled conversion</H>, and a Dental LMS for{' '}
        <H>200+ concurrent learners</H>.
      </>
    ),
  },
]

export default function MyStory() {
  const sectionRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from('.mystory__list li', {
        y: 20,
        opacity: 0,
        duration: 0.5,
        stagger: 0.08,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 80%',
        },
      })
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section ref={sectionRef} id="story" className="section mystory">
      <div className="mystory__wrapper">
        <Meteors
          speed={0.1}
          size={20}
          amount={2}
          colorLightmode="#2978b5"
          colorDarkmode="white"
          fallingSide="left"
        />

        <h2 className="section__title mystory__heading">What I&apos;ve Done</h2>

        <ul className="mystory__list">
          {highlights.map((item) => (
            <li key={item.id}>{item.content}</li>
          ))}
        </ul>
      </div>
    </section>
  )
}
